import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_SOCKET_HOST || "http://localhost:5000", {
  autoConnect: false,
  withCredentials: true,
});

export function saveAnswersViaSocket(event, token, body) {
  return new Promise((resolve, reject) => {
    const retryable = () => Object.assign(new Error("Answer sync connection unavailable. Retrying."), { status: 0 });
    if (!socket.connected) return reject(retryable());
    socket.timeout(12000).emit(event, { token, ...body }, (error, result) => {
      if (error || !result) return reject(retryable());
      if (result.status !== 200) {
        return reject(Object.assign(new Error(result.message || "Unable to save answers."), { status: result.status || 0 }));
      }
      resolve(result);
    });
  });
}

export default socket;
